export default "__VITE_ASSET__2Mz6TaFh__"